import { Button, Grid } from "@mui/material";
import { Question, ResponseType } from "models/batch/Question";
import { QuestionResponse } from "models/batch/QuestionResponse";
import { Attribute } from "models/profile/Attribute";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";

const MDTypography = require("components/MDTypography").default;
const MDButton = require("components/MDButton").default;
export const AttrResponses = ({
  attribute,
  setAttribute,
}: {
  attribute: Attribute;
  setAttribute: any;
}) => {
  const navigate = useNavigate();
  return (
    <Grid container spacing={2}>
      {attribute.questions.map((q: Question, index: number) => (
        <Grid key={index} size={12}>
         {q.id} - {q.txt}
        </Grid>
      ))}
      <Grid container size={12}>
        <MDTypography variant="body2" style={{ fontWeight: "bold" }}>
          {camelCaseToCapitalizedWords(ResponseType[attribute.responseType])}
        </MDTypography>
        <Grid size="grow" />
        {attribute.responseType === ResponseType.Autocomplete && (
          <MDButton
            variant="outlined"
            color="primary"
            onClick={() => navigate(`/attributes/${attribute.name}/autocompleteAnswers`)}
          >
            Show Autocomplete Answers
          </MDButton>
        )}
      </Grid>
      {attribute.responses.map((response: QuestionResponse, index: number) => (
        <Grid key={index} size={12}>
          <MDTypography variant="body2">- {response.txt}</MDTypography>
        </Grid>
      ))}
    </Grid>
  );
};
